import { atom, createStore } from "jotai";

export const $fileInputAtom = atom(null);
export const $modalAtom = atom(null);
export const designsAtom = atom({ continuation: undefined, items: [] });
export const errorAtom = atom(null);
export const intervalIdAtom = atom(null);
export const loadingAtom = atom(false);
export const settingsAtom = atom({});
export const uploadingAtom = atom(false);

export const jotaiStore = createStore();
